var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "linear-scale-container" }, [
    _c("div", { staticClass: "scale-labels" }, [
      _c("span", { staticClass: "label-start" }, [
        _vm._v(_vm._s(_vm.field.scale_text.first))
      ]),
      _vm._v(" "),
      _c("span", { staticClass: "label-end" }, [
        _vm._v(_vm._s(_vm.field.scale_text.last))
      ])
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "scale-button-group" },
      _vm._l(
        _vm.linearRange(_vm.field.scale_range.from, _vm.field.scale_range.to),
        function(i) {
          return _c("div", { key: i, staticClass: "scale-item" }, [
            _c(
              "button",
              {
                staticClass: "scale-button",
                attrs: { type: "button", disabled: "" }
              },
              [_vm._v(_vm._s(i))]
            )
          ])
        }
      ),
      0
    ),
    _vm._v(" "),
    _vm.field.help
      ? _c("span", { staticClass: "help-text" }, [
          _vm._v(_vm._s(_vm.field.help))
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }